// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, socialLoginFromGetStarted } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitSocialLoginGetStartedScreenProfessionalApi = createAsyncThunk(
  "hitSocialLoginGetStartedScreenProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      };
      const url = ApiBaseUrl + socialLoginFromGetStarted;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const SocialLoginGetStartedScreenProfessionalSlice = createSlice({
  name: "socialLoginGetStartedScreenProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearHitSocialLoginGetStartedScreenProfessionalApi: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitSocialLoginGetStartedScreenProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitSocialLoginGetStartedScreenProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        if (
          action.payload?.status == true &&
          action.payload?.data?.accessToken
        ) {
          localStorage.setItem("clientToken", action.payload.data.accessToken);
        }
      })
      .addCase(hitSocialLoginGetStartedScreenProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearHitSocialLoginGetStartedScreenProfessionalApi } = SocialLoginGetStartedScreenProfessionalSlice.actions;
export default SocialLoginGetStartedScreenProfessionalSlice.reducer;
